<div>
	<app-breadcrumbs [selectedClient]="selectedClient"></app-breadcrumbs>
</div>
<div class="container">
	<app-client-selector
		(onSelect)="onSelectClient($event)"
		[selectedUuid]="selectedClient?.uuid"
	></app-client-selector>

	@if (selectedClient) {
		<nz-tabs>
			<nz-tab nzTitle="Purchases">
				@if (!showPurchaseForm) {
					<button (click)="togglePurchaseForm()" nz-button nzType="primary">Add New</button>
					<br />
					<br />
				}
				@if (showPurchaseForm) {
					<app-purchase-form
						[selectedClient]="selectedClient"
						(onSubmit)="onPurchaseSubmit($event)"
					></app-purchase-form>
					<nz-divider></nz-divider>
				}
				<app-purchases-table [selectedClient]="selectedClient"></app-purchases-table>
			</nz-tab>
			<nz-tab nzTitle="Licenses">
				<app-licenses-table [selectedClient]="selectedClient"></app-licenses-table>
			</nz-tab>
			<nz-tab nzTitle="License Consumption Report">
				<h4>Coming Soon</h4>
				<ul>
					<li>
						This report will show what locations and sections are associated with & consuming spots in each
						license.
					</li>
					<li>
						Additionally since we will be allowing clients to 'go over' their license / seat count this
						report will show where that occurs.
					</li>
				</ul>
			</nz-tab>
		</nz-tabs>
	}
</div>
